// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__EQtlF","text":"footer_text__38_sQ"};